import React, { useState, useEffect } from 'react';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import _ from 'lodash';
import { TableFooter, Paper, Modal, EmptyView, Table, IconButton, Spinner, BottomNavigationIcon } from '..';
import { ReactComponent as ImportedSVG } from '../../assets/pictures/campaigns.svg';
import { EMPTY_CAMPAIGNS_TITLE, EMPTY_CAMPAIGNS_TEXT } from '../../constants/dishopInfo';
import { CAMPAIGNS_TABLE_HEAD } from '../../constants/table';
import BackButton from '../BackButton';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { styles } from './MarketingCampaigns.styles';
import { marketing } from '../../constants/mainViewList';
import * as actions from '../../actions/index';
import { CAMPAIGN_TYPES, MARKETING_CAMPAIGN_STATUS_LABEL, MARKETING_CAMPAIGN_STATUS, CAMPAIGN_WITHOUT_PRODUCT_SELECTION, CAMPAIGN_STATUS } from '../../constants/marketingCampaign';
import { handleClose, handleDisabledCampaign, handleRowClick, getAllCampaigns, filterAndSortCampaigns, Campaign, onChangeData } from './MarketingCampaigns.services';
import { getDateFormat } from '../../utils/suitableDate';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { List, ListItem, ListItemText, ListItemIcon } from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { UNIT, mainColor } from '../../constants/theme';
import DetailsModal from './DetailsModal/DetailsModal.view'
import ProductDetailsModal from './DetailsModal/ProductDetailsModal.view';
import { getALLMenus } from '../../apis/backend';
import CampaignPromoModal from '../CampaignPromo/CampaignPromoModal/CampaignPromoModal.view';
import CampaignProductsModal from '../CampaignPromo/CampaignPromoModal/CampainProductsModal.view';
import { handlePromoValidate, getCommonProductsBySection } from '../CampaignPromo/CampaignPromo.services';
import { getBottomNavigationData } from '../../pages/Orders/Orders.services'
const CampaignsComponent: React.FC<any> = (props) => {
    const { classes, history, shops, openErrorModal, showModal } = props
    const [marketingCampaigns, setMarketingCampaigns] = useState<Campaign[]>([]);
    const [openShopsModal, setOpenShopsModal] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isLoadingCampaigns, setIsLoadingCampaigns] = useState<boolean>(false);
    const [isLoadingCompletedCampaigns, setIsLoadingCompletedCampaigns] = useState<boolean>(false);
    const [selectedShops, setSelectedShops] = useState<string[]>([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openDetailsModal, setOpenDetailsModal] = useState<boolean>(false);
    const [openUpdateModal, setOpenUpdateModal] = useState<boolean>(false);
    const [selectedCampaign, setSelectedCampaign] = useState<any>({});
    const [menus, setAllMenu] = useState<any>([]);
    const [sections, setSections] = useState<any>({});
    const [statusSelected, setStatusSelected] = useState<number>(0);
    const iconList = getBottomNavigationData(CAMPAIGN_STATUS);
    const [completedCampaigns, setCompletedCampaigns] = useState<Campaign[]>([]);
    const [changedCampaign, setChangedCampaign] = useState<boolean>(false);
    const [filteredCampaigns, setFilteredCampaigns] =
        useState<Campaign[]>(marketingCampaigns);
    const open = Boolean(anchorEl);
    const withoutProductSelection = CAMPAIGN_WITHOUT_PRODUCT_SELECTION.includes(selectedCampaign?.type)
    const ITEM_HEIGHT = 48;
    const handleButtonClick = (event, campaign) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setSelectedCampaign(campaign);
    };

    const isLoadingData = statusSelected !== 2 ? isLoadingCampaigns : isLoadingCompletedCampaigns;
    const isEmpty = !_.size(filteredCampaigns);
    useEffect(() => {
        const fetchCampaignsData = async () => {

            setIsLoadingCampaigns(true);

            await getAllCampaigns(setMarketingCampaigns, [MARKETING_CAMPAIGN_STATUS.PENDING]);
            const allMenus = await getALLMenus();
            setAllMenu(allMenus);
            setIsLoadingCampaigns(false);
        };
        fetchCampaignsData();
    }, []);

    useEffect(() => {
        const fetchFiltered = async () => {

            const result = await filterAndSortCampaigns(
                marketingCampaigns,
                statusSelected,
                setIsLoadingCompletedCampaigns,
                completedCampaigns,
                changedCampaign,
                setChangedCampaign,
                setCompletedCampaigns
            );

            setFilteredCampaigns(result);
        };

        fetchFiltered();
    }, [statusSelected, marketingCampaigns, completedCampaigns, changedCampaign]);



    useEffect(() => {
        const commonSections = getCommonProductsBySection(selectedCampaign.shopIds, menus);
        setSections(commonSections)
    }, [selectedCampaign, menus]);
    const renderShopsModal = () => {
        return (
            <Modal
                color="secondary"
                title={`Liste  des ${_.size(selectedShops)} restaurants`}
                header
                fixed
                width="500px"
                onClick={() => setOpenShopsModal(false)}
                btnTxt="Retour"
                handleClose={() => setOpenShopsModal(false)}
                isOpen={openShopsModal}
            >
                <List className={`${classes.paddingStyle} p-0`}
                    dense={true}
                    disablePadding={false} >
                    {_.map(selectedShops, shopId => (

                        <ListItem key={shopId} className='py-0'>
                            <ListItemIcon style={{ color: 'black', minWidth: '14px' }}>
                                <FiberManualRecordIcon style={{ fontSize: '10px' }} />
                            </ListItemIcon>
                            <ListItemText primary={shops[shopId]?.name} />
                        </ListItem>

                    ))}
                </List>
            </Modal >
        )
    }

    const createTableRow = (rows) => {
        return (
            <TableBody>
                {_.map(rows, e => {
                    const { type, status = '', shopIds = {}, dateStart, dateEnd, nbUsed, marketingCampaignKey } = e;
                    const availableStatus = status === MARKETING_CAMPAIGN_STATUS.IN_PROGRESS || status === MARKETING_CAMPAIGN_STATUS.NOT_STARTED
                    return (
                        <TableRow
                            key={marketingCampaignKey}
                            style={{ cursor: 'pointer' }}
                            onClick={event => {
                                event.stopPropagation();
                                setOpenDetailsModal(true)
                                handleRowClick(e, setSelectedCampaign)
                            }}
                        >
                            <TableCell align="center" className={classes.valueC}>
                                {CAMPAIGN_TYPES[type]}
                            </TableCell>
                            <TableCell align="center" className={classes.valueC}
                                style={{
                                    color: `${MARKETING_CAMPAIGN_STATUS_LABEL[status]?.color}` || 'inherit',
                                }}>
                                {MARKETING_CAMPAIGN_STATUS_LABEL[status]?.label}
                            </TableCell>
                            <TableCell align="center" className={classes.valueC}>
                                {_.size(shopIds) > 1 ? (
                                    <>
                                        {`${_.size(shopIds)} restaurant(s)`}
                                        <IconButton
                                            className={classes.icon}
                                            disablePortal={false}
                                            title="Informations"
                                            onClick={e => {
                                                setOpenShopsModal(true);
                                                setSelectedShops(shopIds);
                                                e.stopPropagation();
                                            }}
                                        >
                                            <InfoOutlinedIcon />
                                        </IconButton>
                                    </>
                                ) : (
                                    shops?.[shopIds[0]]?.name
                                )}
                            </TableCell>

                            <TableCell align="center" className={classes.valueC}>
                                {getDateFormat(dateStart, 'DD/MM/YYYY')}{' => '} {getDateFormat(dateEnd, 'DD/MM/YYYY')}
                            </TableCell>
                            <TableCell align="center" className={classes.valueC}>
                                {nbUsed}
                            </TableCell>

                            <TableCell align="center" className={classes.valueC}>

                                <>
                                    <IconButton
                                        aria-label='more'
                                        aria-controls='long-menu'
                                        aria-haspopup='true'
                                        onClick={(event) => handleButtonClick(event, e)}

                                    >
                                        <MoreVertIcon className={classes.icon} />
                                    </IconButton>
                                    <Menu
                                        id='long-menu'
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={() => { handleClose(setAnchorEl) }}
                                        PaperProps={{
                                            style: {
                                                maxHeight: ITEM_HEIGHT * 4.5,
                                                width: '20ch',
                                                borderRadius: UNIT * 0.5625,
                                                boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.07)'
                                            }
                                        }}
                                        onClick={(event) => event.stopPropagation()}
                                    >
                                        <MenuItem
                                            onClick={event => {
                                                event.stopPropagation();
                                                setOpenDetailsModal(true)
                                                setAnchorEl(null);
                                            }}
                                        >

                                            Détails

                                        </MenuItem>
                                        {availableStatus &&
                                            <MenuItem
                                                onClick={event => {
                                                    handleDisabledCampaign(selectedCampaign, showModal, openErrorModal, setMarketingCampaigns, setChangedCampaign);
                                                    setAnchorEl(null);
                                                    event.stopPropagation();
                                                }}
                                            >

                                                Désactiver

                                            </MenuItem>
                                        }
                                        {selectedCampaign?.status === MARKETING_CAMPAIGN_STATUS.NOT_STARTED &&
                                            <MenuItem
                                                onClick={event => {
                                                    event.stopPropagation();
                                                    setOpenUpdateModal(true)
                                                    setAnchorEl(null);
                                                }}
                                            >

                                                Modifier

                                            </MenuItem>
                                        }
                                    </Menu>
                                </>
                            </TableCell>
                        </TableRow>
                    );
                })
                }
            </TableBody >
        );
    };
    return (
        <div className="p-4">
            <BackButton
                className="p-0"
                onClick={() => history.goBack()}
                title={marketing.campaigns.text}
                subtitle={marketing.campaigns.description}
            />
            <div className='mt-3 p-0 col-sm-12 col-md-7 col-lg-6 col-xl-4'>
                <Paper className={classes.paperStyle}>
                    <BottomNavigationIcon
                        value={statusSelected}
                        onChange={(event, newValue) => onChangeData(event, newValue, setStatusSelected, props)}
                        showLabels={true}
                        collection={iconList}
                        withoutIcon={true}
                    />
                </Paper>
            </div>

            {isLoadingData ? (
                <div
                    style={{
                        padding: UNIT * 5,
                        textAlign: 'center',
                        color: `rgba(${mainColor.rgb}, 1)`,
                        alignSelf: 'center',
                    }}
                >
                    <Spinner />
                </div>
            ) : isEmpty ? (
                <EmptyView
                    src={ImportedSVG}
                    title={EMPTY_CAMPAIGNS_TEXT}
                    text={EMPTY_CAMPAIGNS_TITLE}
                />
            ) : (
                <>
                    <Paper scrollOption="auto" className="mt-3">
                        <Table
                            headCells={CAMPAIGNS_TABLE_HEAD}
                            classes={classes}
                            bodyRows={filteredCampaigns}
                            createTableRow={(rows) => createTableRow(rows)}
                            withEmptyCell
                            order={undefined}
                            orderBy={undefined}
                        />
                    </Paper>
                    <TableFooter lengthOption={_.size(filteredCampaigns)} />
                </>
            )}
            {openShopsModal && renderShopsModal()}
            {openDetailsModal && (
                withoutProductSelection ?
                    <DetailsModal
                        classes={classes}
                        showModal={!!selectedCampaign}
                        selectedCampaign={selectedCampaign}
                        handleClose={() => setOpenDetailsModal(false)}
                    /> :

                    <ProductDetailsModal
                        classes={classes}
                        showModal={!!selectedCampaign}
                        selectedCampaign={selectedCampaign}
                        menus={menus}
                        handleClose={() => setOpenDetailsModal(false)}
                    />
            )}
            {openUpdateModal && (
                withoutProductSelection ?
                    <CampaignPromoModal
                        classes={classes}
                        showModal={!!selectedCampaign}
                        loading={isLoading}
                        selectedCampaign={selectedCampaign}
                        onClick={(formValues) => handlePromoValidate(formValues, selectedCampaign?.shopIds, setOpenUpdateModal, setOpenUpdateModal, openErrorModal, setIsLoading, true, true, setMarketingCampaigns)}
                        handleClose={() => setOpenUpdateModal(false)}
                        isUpdate={true}
                    /> :

                    <CampaignProductsModal
                        classes={classes}
                        showModal={!!selectedCampaign}
                        loading={isLoading}
                        selectedCampaign={selectedCampaign}
                        selectedShops={selectedCampaign?.shopIds}
                        allMenus={menus}
                        onClick={(formValues) => handlePromoValidate(formValues, selectedCampaign?.shopIds, setOpenUpdateModal, setOpenUpdateModal, openErrorModal, setIsLoading, false, true, setMarketingCampaigns)}
                        openErrorModal={openErrorModal}
                        handleClose={() => setOpenUpdateModal(false)}
                        isUpdate={true}
                        sections={sections}
                    />
            )}
        </div>
    );
};

function mapStateToProps({ firebaseRealTime, page }) {
    const { shops = {} } = firebaseRealTime
    const { rowsPerPage } = page
    return { shops, rowsPerPage };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(CampaignsComponent)));
